<template>
    <div class="entrywrap">
        <b-container fluid class="entries" tabindex="0" @keydown="doListKeyDown">
            <address-book-entry v-for="(e,ind) in sortedEntries" :key="ind" :entry="e"
                    :selected="selectIndex === ind" ref="list" @click="doClick(ind)"
                    :scopes="scopes"></address-book-entry>
        </b-container>
    </div>
</template>

<script>
import AddressBookEntry from '@/components/addressBookEntry';

export default {
  name: 'addressBookEntries',
  components: { AddressBookEntry },
  data: function() {
    return {
      selectIndex: 0
    };
  },
  props: {
    selectedDN: String,
    scopes: Array,
    searchText: String
  },
  methods: {
    doClick(ind) {
      this.selectIndex = ind;
      this.$emit('select', this.sortedEntries[ind].dn);
    },
    doListKeyDown(evt) {
      let delta = 0;
      if (evt.key === 'ArrowDown') {
        delta = 1;
      } else if (evt.key === 'ArrowUp') {
        delta = -1;
      } else if (evt.key === 'Home') {
        delta = -this.sortedEntries.length;
      } else if (evt.key === 'End') {
        delta = this.sortedEntries.length;
      } else if (evt.key === 'PageUp') {
        delta = -10;
      } else if (evt.key === 'PageDown') {
        delta = 10;
      }

      if (delta) {
        evt.preventDefault();
        let newIndex = this.selectIndex + delta;
        if (newIndex >= this.sortedEntries.length) {
          newIndex = this.sortedEntries.length - 1;
        }
        if (newIndex < 0) {
          newIndex = 0;
        }

        if (newIndex !== this.selectIndex) {
          this.selectIndex = newIndex;
          this.$refs.list[this.selectIndex].scrollIntoView();
        }
      }
    }
  },
  computed: {
    scopeId() {
      const scope = this.scopes.find(s => s.dn === this.selectedDN);
      if (scope) {
        return scope.id;
      } else {
        return 0;
      }
    },
    filteredEntries() {
      const parentDN = ',' + this.selectedDN;
      const entries = this.$store.state.addressBookEntries;
      const searchText = this.searchText.toLocaleUpperCase();
      return Object.keys(entries)
        .filter(dn => dn.indexOf(parentDN) !== -1)
        .filter(dn => {
          return (entries[dn].cn.toLocaleUpperCase().indexOf(searchText) !== -1);
        })
        .reduce((result, dn) => {
          result.push({ dn: dn, ...entries[dn] });
          return result;
        }, []);
    },
    sortedEntries() {
      const sorted = this.filteredEntries.slice();
      sorted.sort((a, b) => {
        return a.cn.localeCompare(b.cn);
      });
      return sorted;
    }
  }
};
</script>

<style scoped lang="scss">
    .entrywrap {
        height: 100%;
        overflow-y: auto;
    }
    .entries {
        // height: 100%;
        // overflow-y: scroll;
    }

</style>
